import React from 'react';
import { Button, FormGroup, Input, Label } from '../../../../components/Bootstrap';
import { NobleModal } from '../../../../components';
import { MenuOption } from '../../types';
import { useInputState } from '../../../../hooks';

interface OptionFreeformEditorProps {
  name: string;
  onCancel();
  onSubmit(options: MenuOption[]);
}

export const OptionFreeformEditor: React.FC<OptionFreeformEditorProps> = ({ onSubmit, onCancel, name: labelName }) => {
  const [name, setName] = useInputState('');
  const [price, setPrice] = useInputState('0');
  const onSubmitWrapped = React.useCallback(
    (e) => {
      e.preventDefault();

      onSubmit([
        {
          __typename: 'MenuOption' as 'MenuOption',
          id: null,
          price: Number(price),
          enabled: true,
          option: {
            __typename: 'Option' as 'Option',
            id: null,
            imageUrl: null,
            name,
            posInfo: null,
            posPrice: null,
          },
        },
      ]);
    },
    [name, price, onSubmit]
  );

  return (
    <NobleModal.Body>
      <div className='option-modal-content'>
        <FormGroup>
          <Label for='option'>{labelName}</Label>
          <Input value={name} onChange={setName} id='value' placeholder='' />
        </FormGroup>
        <FormGroup>
          <Label for='price'>Upgrade Price</Label>
          <Input type='number' value={price} onChange={setPrice} name='number' id='price' placeholder='$0' />
        </FormGroup>
        <div className='text-center'>
          <Button type='button' color='link' onClick={onCancel}>
            Cancel
          </Button>{' '}
          <Button type='button' color='primary' onClick={onSubmitWrapped}>
            Save
          </Button>
        </div>
      </div>
    </NobleModal.Body>
  );
};
